import * as React from "react";
import { combine } from "../utils";
import { IconButton, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        leftBorderRadius: {
            borderRadius: "50% 0 0 50%"
        },
        rightBorderRadius: {
            borderRadius: "0 50% 50% 0"
        },
        buttonContainer: {
            display: "flex"
        },
        button: {
            height: 36,
            width: 36,
            padding: 0
        },
        buttonText: {
            lineHeight: 1.6
        },
        outlined: {
            border: "1px solid " + theme.palette.primary.dark
        },
        filled: {
            "&:hover": {
                backgroundColor: theme.palette.primary.dark
            },
            backgroundColor: theme.palette.primary.dark
        },
        highlighted: {
            backgroundColor: theme.palette.action.hover
        },
        contrast: {
            color: theme.palette.primary.contrastText
        }
    });
});
var Day = function (props) {
    var classes = useStyles();
    return (React.createElement("div", { className: combine(classes.buttonContainer, props.startOfRange && classes.leftBorderRadius, props.endOfRange && classes.rightBorderRadius, !props.disabled && props.highlighted && classes.highlighted) },
        React.createElement(IconButton, { className: combine(classes.button, !props.disabled && props.outlined && classes.outlined, !props.disabled && props.filled && classes.filled), disabled: props.disabled, onClick: props.onClick, onMouseOver: props.onHover },
            React.createElement(Typography, { className: combine(classes.buttonText, !props.disabled && props.filled && classes.contrast), variant: "body2" }, props.value))));
};
export default Day;
//# sourceMappingURL=Day.js.map